import useAuth from '@/hooks/useAuth';
import timezoneService from '@/services/timezone.service';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { INotificationProps } from './components/notification.component';

export function useNotificationsController() {
	const { t } = useTranslation();
	const { impersonatedUser, impersonate, getCurrentUser } = useAuth();
	const history = useHistory();
	const notifications: Array<INotificationProps> = [];

	if (impersonatedUser) {
		notifications.push({
			title: t('You are impersonating'),
			subtitle: impersonatedUser.email,
			action: {
				text: t('Stop'),
				onClick: () => impersonate(undefined),
			},
		});
	}

	if (timezoneService.getTimeZone() !== getCurrentUser().timeZone) {
		notifications.push({
			title: t('New timezone detected.'),
			subtitle: timezoneService.getTimeZone(),
			action: {
				text: t('Read more'),
				onClick: () => history.replace(`${history.location.pathname}?viewTzModal=true`),
			},
		});
	}

	return {
		t,
		notifications,
	};
}
